var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chart-wrapper", style: { height: 46 } },
    [
      _c(
        "v-chart",
        {
          attrs: {
            "force-fit": true,
            height: _vm.height,
            data: _vm.dataSource,
            padding: _vm.chartConfig.padding,
            scale: _vm.scale,
          },
        },
        [
          _c("v-tooltip"),
          _vm.showXAxis
            ? _c("v-axis", { attrs: { dataKey: "x", visible: true } })
            : _vm._e(),
          _vm.showXAxis
            ? _c("v-axis", {
                attrs: {
                  dataKey: "y",
                  visible: false,
                  line: false,
                  tickLine: false,
                  label: false,
                  grid: false,
                },
              })
            : _vm._e(),
          _c("v-smooth-area", { attrs: { position: "x*y" } }),
          _c("v-smooth-line", {
            attrs: { position: "x*y", label: _vm.label2 },
          }),
          _c("v-point", { attrs: { position: "x*y", shape: "circle" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }